// extracted by mini-css-extract-plugin
export default {"header-nav-link":"header-nav-link_header-nav-link__1beQu","active":"header-nav-link_active__sUuft","flexGrid":"header-nav-link_flexGrid__X+3or"};